// Formatting helpers for src/content.json (generated from Supabase by scripts/fetch-content.js).
const year = (month) => (month ? month.slice(0, 4) : '');

// "2024 – Present", "2022 – 2023", "2023", or '' when no dates are set yet.
export function roleDates(role) {
  if (!role.start_month) return '';
  const end = role.is_current ? 'Present' : year(role.end_month);
  if (!end) return year(role.start_month);
  return end === year(role.start_month) ? end : `${year(role.start_month)} – ${end}`;
}
